import * as types from '../actions/actionTypes';
import initialState from './initialState';


export default function coursesReducer(state = initialState.courses, action) {
    let newState;

    switch (action.type) {
        case types.LOAD_COURSES_SUCCESS:
            return action.courses;
        case types.CREATE_COURSE_SUCCESS:
            return [...state, Object.assign({}, action.course)];
        case types.UPDATE_COURSE_SUCCESS:
            newState = {...state};
            newState.data = [
                ...newState.data.filter(course => course.id !== action.course.id),
                Object.assign({}, action.course)
            ];

            return newState;
        case types.DELETE_COURSE_SUCCESS:
            newState = {...state};
            newState.data = newState.data.filter(course => course.id !== action.id);
            newState.total = newState.total - 1;
            return newState;
            break;
        case types.CLONE_COURSE_SUCCESS:
            let copiedCourse = action.course;
            const total = state.total;

            const data = [...state.data, copiedCourse];

            // data.push(copiedCourse);

            return Object.assign(action, {
                data,
                'total': total+1
            });
            break;
        case types.CLEAR_COURSES_LIST:
            return [];
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./web/src/reducers/coursesReducer.js